export default __webpack_public_path__ + "static/media/tiktok-bg-desktop.a9b52f36.png";